<template>
	<Modal
		:allow-close="true"
		:close-button-absolute="true"
		:hide-actions="true"
		:max-width="'max-w-[485px]'"
		rounded-size="rounded-[10px]"
		:prevent-scrolling="false"
		:remove-padding="true"
		@modal:close="store.close()"
	>
		<template #body>
			<div class="flex flex-col items-center gap-4 px-6 pt-11 pb-6 text-center font-[Inter]">
				<div class="flex flex-col items-center gap-2">
					<img
						:src="RESUME_NEEDS_DETAIL_IMAGE"
						alt=""
						width="64"
						height="64"
					/>
					<h2 class="text-xl leading-7 font-semibold text-gray-900">
						Your resume needs a bit more detail
					</h2>
					<p class="text-sm leading-5 text-gray-500">
						ResumAI will help you fill in the gaps. Most people are ready to apply in under 15 minutes.
					</p>
				</div>

				<div class="flex w-full max-w-[320px] flex-col gap-2">
					<button
						type="button"
						class="h-9 w-full rounded-md bg-won-green px-3 text-sm font-medium text-white hover:bg-won-green/90"
						@click="completeWithResumAi"
					>
						Complete with ResumAI
					</button>
					<button
						type="button"
						class="h-9 w-full rounded-md bg-gray-100 px-3 text-sm font-medium text-gray-900 hover:bg-gray-200"
						@click="store.requestResumeUpload()"
					>
						Upload Another Resume
					</button>
				</div>
			</div>
		</template>
	</Modal>
</template>

<script setup>
import { useRouter } from 'vue-router';

import Modal from '../../components/modal.vue';
import { useExistingUserAutoApplyStore } from '../../store/existing-user-auto-apply.store';

// public/img assets need a bound :src — a literal src attribute breaks Vite's import analysis.
const RESUME_NEEDS_DETAIL_IMAGE = '/img/resume-needs-detail.svg';

const router = useRouter();
const store = useExistingUserAutoApplyStore();

const completeWithResumAi = () => {
	router.push(`/resume/${store.resumeUuid}`);
	store.close();
};
</script>
